import { notifications } from "@mantine/notifications"
import { IconCheck, IconX, IconAlertTriangle } from "@tabler/icons-react"

export const notificationSuccess = (title, message) => {
  return notifications.show({
    title: title,
    message: message,
    withCloseButton: true,
    withBorder: true,
    icon: <IconCheck size='1.1rem' />,
    color: 'teal'
  })
}

export const notificationError = (title, message) => {
  return notifications.show({
    title: title,
    message: message,
    withCloseButton: true,
    withBorder: true,
    icon: <IconX size='1.1rem' />,
    color: 'red'
  })
}

export const notificationWarning = (title, message) => {
  return notifications.show({
    title: title,
    message: message,
    withCloseButton: true,
    withBorder: true,
    icon: <IconAlertTriangle size='1.1rem' />,
    color: 'yellow'
  })
}

export const loadingNotification = (id, title, message) => {
  return notifications.show({
    id,
    loading: true,
    title: title,
    message: message,
    autoClose: false,
    withCloseButton: false,
  })
}

export const completedLoadingNotification = (id, title, message) => {
  notifications.update({
    id,
    color: 'teal',
    title: title,
    message: message,
    icon: <IconCheck size={18} />,
    loading: false,
    autoClose: 2000,
  })
}

export const failedLoadingNotification = (id, title, message) => {
  notifications.update({
    id,
    color: 'red',
    title: title,
    message: message,
    icon: <IconX size='1.1rem' />,
    loading: false,
    autoClose: 2000,
  })
}
